// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {

});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", async function (evt) {
  const cart = evt.detail.cart;

  // 直接使用事件中的购物车数据
  checkAndUpdateFreeShippingBar(cart);
});


// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {

});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  setTimeout(() => {
    checkAndUpdateFreeShippingBar();
  }, 100);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {

});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {

});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {

});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(document);
  if (typeof window !== 'undefined') {
    window.ProductContextCache = window.ProductContextCache || {};
    window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
  }
  renderInitialVariant(productData);

});



// ================================================================================
// "Quick add" events
//
// - Fires when quick-add modal is opened / closed, or when quick-add reports an error
// - "detail" object data for open: { type, productUrl, productTitle }
// - "detail" object data for error: { id, errorMessage }
// ================================================================================
document.addEventListener('quick-add:loaded', function (evt) {
  console.log('quick-add opened');
  
  // Get the modal element from event detail
  const modalElement = evt && evt.detail && evt.detail.quickAdd;
  
  // Search within the modal content if available, otherwise fallback to document
  const searchContext = modalElement || document;
  
  // Retry mechanism to ensure data is loaded
  let attempts = 0;
  const maxAttempts = 5;
  
  const tryLoadProductData = () => {
    attempts++;
    
    const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(searchContext);
    
    // Check if we got valid product data
    if (productData && productData.variants && productData.variants.length > 0) {
      if (typeof window !== 'undefined') {
        window.ProductContextCache = window.ProductContextCache || {};
        window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
      }
      
      console.log('Product data loaded successfully, rendering initial variant');
      renderInitialVariant(productData, true); // Pass true for isModalContext
    } else if (attempts < maxAttempts) {
      // Retry after a delay if data not ready yet
      console.log(`Product data not ready, retry attempt ${attempts}/${maxAttempts}`);
      setTimeout(tryLoadProductData, 150);
    } else {
      console.warn('Failed to load product data after maximum attempts');
    }
  };
  
  // Start first attempt after initial delay
  setTimeout(tryLoadProductData, 200);
});

document.addEventListener('quick-add:close', function (evt) {
  // Quick add modal closed. evt.detail may be undefined.
  // Add custom teardown logic here if needed.
  // console.log('quick-add closed');
});

document.addEventListener('quick-add:error', function (evt) {
  const { id, errorMessage } = (evt && evt.detail) ? evt.detail : {};
  // Handle quick-add specific errors (usually quantity/stock related)
  if (errorMessage) {
    console.warn('quick-add error', id || '', errorMessage);
    // Optionally surface error to UI or analytics here
  }
});

document.addEventListener("confirmation-popup:open", function (evt) {
  setTimeout(() => {
    checkAndUpdateFreeShippingBar();
  }, 200);
});


document.addEventListener('DOMContentLoaded', function () {
  checkAndUpdateFreeShippingBar();

  const purchaseConfirmationPopup = document.querySelector('[data-purchase-confirmation-popup]');
  if (purchaseConfirmationPopup) {
    const contentObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const hasNewContent = Array.from(mutation.addedNodes).some(node =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.classList.contains('purchase-confirmation-popup__inner') ||
              node.querySelector && node.querySelector('.purchase-confirmation-popup__inner'))
          );

          if (hasNewContent) {
            setTimeout(() => {
              checkAndUpdateFreeShippingBar();
            }, 100);
          }
        }
      });
    });

    const classObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('active')) {
            setTimeout(() => {
              checkAndUpdateFreeShippingBar();
            }, 300);
          }
        }
      });
    });

    contentObserver.observe(purchaseConfirmationPopup, {
      childList: true,
      subtree: true
    });

    classObserver.observe(purchaseConfirmationPopup, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});

/* eslint-enable no-console */


function checkAndUpdateFreeShippingBar(cartData = null) {
  // 如果传入了购物车数据，直接使用；否则通过API获取
  if (cartData) {
    updateFreeShippingBarDisplay(cartData);
  } else {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateFreeShippingBarDisplay(cart);
      })
      .catch(error => {
      });
  }
}

// 提取显示逻辑到单独的函数
function updateFreeShippingBarDisplay(cart) {
  let isFreeShipping = true;

  cart.items.forEach((item) => {
    if (item.properties && !item.properties._is_free_shipping) {
      isFreeShipping = false;
      return;
    }
  });


  const freeShippingBars = document.querySelectorAll('.free-shipping-bar');
  freeShippingBars.forEach(bar => {
    if (isFreeShipping) {
      bar.classList.add('hidden');
    } else {
      bar.classList.remove('hidden');
    }
  });
}
